import { EntitySelect, EntitySelectEntity } from '@factorialco/f0-react/dist/experimental'
import { WorkflowRoleSelectorDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { EntitySelectorComponent } from 'modules/workflows/components/Sidepanel/VariableSelectorTypes'

const RoleSelector: EntitySelectorComponent = ({ value, onChange, error }) => {
  const { data, loading: rolesLoading } = useQuery(WorkflowRoleSelectorDocument)

  const availableRoles = data?.jobCatalog?.rolesConnection?.nodes || []
  const selectedRole = value ? availableRoles.find((role) => role.id === value) : undefined
  const selectedEntities = selectedRole
    ? [{ id: selectedRole.id, name: selectedRole.name, avatar: undefined }]
    : []
  return (
    <EntitySelect
      label="Select role..."
      hideLabel
      loading={rolesLoading}
      size="md"
      entities={availableRoles.map(({ id, name }) => ({
        avatar: undefined,
        expanded: false,
        id,
        name,
      }))}
      notFoundSubtitle="No roles found"
      notFoundTitle="Roles not found"
      onGroupChange={() => {}}
      onItemExpandedChange={() => {}}
      onSelect={(selection: EntitySelectEntity | null) => {
        onChange(selection?.id ?? null)
      }}
      searchPlaceholder="Search roles..."
      selectedEntities={selectedEntities}
      selectedLabel="Selected"
      singleSelector
      placeholder="Select role..."
      selectedItemsCopy="Roles selected"
      groups={[]}
      selectedGroup="all"
      clearLabel="Clear"
      selectAllLabel="Select all"
      error={error}
    />
  )
}

export default RoleSelector
